import { render, staticRenderFns } from "./setBrandSample.vue?vue&type=template&id=b0c86a8a&"
import script from "./setBrandSample.vue?vue&type=script&lang=js&"
export * from "./setBrandSample.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.0@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports